import { useEffect } from 'react';

import { useSocialIntegrationsWs } from '@app/shared/components/SocialIntegrationsWarning/hooks/useSocialIntegrationsWs';
import type { UseSocialIntegrationsWsOptions } from '@app/shared/components/SocialIntegrationsWarning/hooks/useSocialIntegrationsWs';

interface UseSocialIntegrationsWarningEffectsProps {
  onRestoreStatus: () => void;
  onWsChange: UseSocialIntegrationsWsOptions['onChange'];
}

export const useSocialIntegrationsWarningEffects = ({
  onRestoreStatus,
  onWsChange,
}: UseSocialIntegrationsWarningEffectsProps) => {
  useSocialIntegrationsWs({ onChange: onWsChange });

  useEffect(() => {
    onRestoreStatus();
  }, [onRestoreStatus]);
};
